import React, { Component } from 'react';

export default class Welcome extends Component {

  componentDidMount() {
  }

  render() {
    return (
      <div className="auth">
        { this.props.children }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/welcome.jsx